import { useSelector } from 'react-redux'

import { isMarketplaceSelector, isPrintAssetSelector } from '@/selectors'

import BisacSubjects from './BisacSubjects'
import BookTitle from './components/BookTitle'
import DescriptionContent from './components/DescriptionContent'
import DigitalPurchaseMessage from './components/DigitalPurchaseMessage'
import OtherIdentifiers from './components/OtherIdentifiers'
import WhatIsMarketplaceMessage from './components/WhatIsMarketplaceMessage'
import CoursewareInformation from './CoursewareInformation'
import ReturnPolicy from './ReturnPolicy'

const Description = () => {
  const isPrintAsset = useSelector(isPrintAssetSelector)
  const isMarketplace = useSelector(isMarketplaceSelector)

  return (
    <section className='tab-description d-lg-flex flex-lg-row'>
      <div className='limit-width'>
        <BookTitle />
        <DescriptionContent />
      </div>
      <div className='limit-width right-side'>
        <CoursewareInformation />
        <OtherIdentifiers />
        <BisacSubjects />
        <ReturnPolicy />
        <If condition={!isPrintAsset}>
          <DigitalPurchaseMessage />
        </If>
        <If condition={isMarketplace}>
          <WhatIsMarketplaceMessage />
        </If>
      </div>
    </section>
  )
}

export default Description
